import React, { useState, useRef } from "react";
import CodeExecutor from "../../../../components/CodeExecutor/CodeExecutor.js";
import {
  Card,
  Row,
  Col,
  CardHeader,
  CardBody,
  CardTitle,
  CardText,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  FormGroup,
  Label,
  Input,
  CardFooter,
  Container
} from "reactstrap";
import LessonNavBar from "components/Navbars/LessonNavBar.js";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import { CheckCode } from "./CheckCode.js";
import MainFooter from "../../../../components/Footers/MainFooter.js";

import classnames from "classnames";
import { useLesson } from "../../../../hooks/lessonFramework.js";
import { useUserAuth } from "../../../../context/UserContext.js";
import NavigationButton from "../../../../components/NavigationButton/NavigationButton.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChalkboardUser, faSquareCheck, faRobot } from "@fortawesome/free-solid-svg-icons";

import { CODESNIPPET } from "../../../../constants/codeSnippet.js";
import Highlight, { defaultProps } from "prism-react-renderer";
import github from "prism-react-renderer/themes/github";
import AIAssistant from "pages/AI/AIAssistant.js";

const IndentationInJavaComponent = () => {
  const lessonID = "JA101";
   const { lessonCode, setInitialCode } = useLesson();
   const mainRef = useRef(null);
   const { user } = useUserAuth();
   const [activeTab, setActiveTab] = useState("1");

  const executeTests = (code, output) => {
    const newCheckedStates = CheckCode(code, output, checkedStates, user, lessonID);
    updateCheckboxState(newCheckedStates);
  };

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  // CHECKBOXS
  const [checkedStates, setCheckedStates] = useState({
    checkbox1: false,
    checkbox2: false,
    checkbox3: false,
    checkbox4: true,
  });

  // Function to update the state of specific checkboxes
  const updateCheckboxState = (updates) => {
    setCheckedStates((prevState) => ({
      ...prevState,
      ...updates, // Merge the updates into the current state
    }));
  };
  // CHECKBOXS

  return (
    <>
      <div className=" lessonBackgroundColor1 lessonMain  h-100vh" >
        <LessonNavBar />
        <main id="main" tabIndex={-1} className="lessonMain flex-grow-1">
          <section>
            <Container fluid className=" pr-0 pl-0   fullWitdthHeight ">
              <CodeExecutor languageCode="java" initialCode={lessonCode} runTestCase={executeTests}>
                <Card className="fullWitdthHeight">
                  <CardHeader className=" lesson-header">Indentation in Java</CardHeader>
                  <TabContent className="fullWitdthHeight overflow-auto " activeTab={activeTab}>
                    <TabPane className="fullWitdthHeight" tabId="1">
                      <CardBody>
                        <CardTitle tag="h5">
                          How to Use Indentation in Java
                        </CardTitle>
                        <CardText>
                          {'1.	In Java, indentation is typically done using four spaces or one tab per level'}
                        </CardText>
                        <CardText>
                          2.	<b>Maintain Consistency:</b> Choose either spaces or tabs for indentation and stick to it throughout your program.
                        </CardText>
                        <CardText>
                          3.	<b>Indentation for blocks:</b> Code inside curly braces ({ }) should be indented.
                        </CardText>
                        <CardText>
                          Example:
                        </CardText>
                        <CardText>
                          <Highlight {...defaultProps} theme={github} code={CODESNIPPET.IdentationInJavaCode1} language="java">
                            {({ style, tokens, getLineProps, getTokenProps }) => (
                              <pre style={{ ...style, padding: "15px", borderRadius: "5px", overflowX: "auto" }}>
                                {tokens.map((line, i) => (
                                  <div key={i} {...getLineProps({ line, key: i })}>
                                    {line.map((token, key) => (
                                      <span key={key} {...getTokenProps({ token, key })} />
                                    ))}
                                  </div>
                                ))}
                              </pre>
                            )}
                          </Highlight>
                        </CardText>
                        <CardText>
                          4.	Align closing braces with their opening braces:
                        </CardText>
                        <CardText>
                          Example:
                        </CardText>
                        <CardText>
                          <Highlight {...defaultProps} theme={github} code={CODESNIPPET.IdentationInJavaCode2} language="java">
                            {({ style, tokens, getLineProps, getTokenProps }) => (
                              <pre style={{ ...style, padding: "15px", borderRadius: "5px", overflowX: "auto" }}>
                                {tokens.map((line, i) => (
                                  <div key={i} {...getLineProps({ line, key: i })}>
                                    {line.map((token, key) => (
                                      <span key={key} {...getTokenProps({ token, key })} />
                                    ))}
                                  </div>
                                ))}
                              </pre>
                            )}
                          </Highlight>
                        </CardText>

                      </CardBody>
                    </TabPane>

                    <TabPane tabId="2">
                      <CardBody>
                        {/* CHECKBOXS */}
                        <h4>Try It Yourself</h4>
                        <div className="checkBoxSeparator">
                          <FormGroup check>
                            <Label check>
                              <Input
                                type="checkbox"
                                name="checkbox1"
                                checked={checkedStates.checkbox1}
                                readOnly
                              />
                              The following Java program has incorrect indentation. Fix the indentation to make it properly structured and readable. Use <b>4 spaces or a tab</b> for each level of indentation.
                            </Label>
                          </FormGroup>
                        </div>
                        {/* CHECKBOXS */}
                      </CardBody>
                    </TabPane>
                    <TabPane tabId="3">
                      <CardBody>
                        <AIAssistant></AIAssistant>
                      </CardBody>
                    </TabPane>
                  </TabContent>
                  <CardFooter className=" lesson-footer">
                    <Nav tabs className="justify-content-center my-nav-tabs ">
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "1" })}
                          onClick={() => toggle("1")}
                        >
                          <FontAwesomeIcon icon={faChalkboardUser} size="lg" />
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "2" })}
                          onClick={() => toggle("2")}
                        >
                          <FontAwesomeIcon icon={faSquareCheck} size="lg" />
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "3" })}
                          onClick={() => toggle("3")}
                        >
                          <FontAwesomeIcon icon={faRobot} size="lg" />
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </CardFooter>
                </Card>
              </CodeExecutor>
            </Container>
          </section>
          <section >
            <Container className="container-lg">
              <Row className=" p-3   align-items-center  justify-content-between">
                <NavigationButton direction="back" page="indentation"></NavigationButton>
                <NavigationButton direction="next" page=""></NavigationButton>
              </Row>
            </Container>
          </section>
        </main>
      </div>
    </>
  );
};

export default IndentationInJavaComponent;
